'use client';
import Script from 'next/script';
import { usePathname } from 'next/navigation';

const MicrosoftClarity = () => {
    const pathname = usePathname();

    // Define routes where Clarity should NOT be shown (consistent with GTM)
    const isExcluded =
        pathname?.startsWith('/customer-dashboard') ||
        pathname?.startsWith('/freelancer-dashboard') ||
        pathname?.startsWith('/control') ||
        pathname?.startsWith('/(superadmin)') ||
        pathname?.startsWith('/dashboard');

    if (isExcluded) return null;

    return (
        <Script
            id="microsoft-clarity"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `
                (function(c,l,a,r,i,t,y){
                    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                })(window, document, "clarity", "script", "w1w7tao8zj");
                `,
            }}
        />
    );
};

export default MicrosoftClarity;
